export default "__VITE_ASSET__8edd10ec__"